import React, { useState } from "react"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import { DEPARTMENT_LIST } from "graphql/department.graphql"
import ButtonMutation from "components/Molecules/ButtonMutation"
import { BULK_UPDATE_VEHICLE_DEPARTMENTS } from "graphql/vehicle/vehicle.mutations.gql"
import { useSelectedVehicles } from "store/all-vehicles/all-vehicles.types"
import { getId } from "utils/custom.utils"
import AppToaster from "utils/AppToaster"

function UpdateDepartments() {
  const [departments, setDepartments] = useState([])
  const selected = useSelectedVehicles()
  return (
    <>
      <DynamicMultiSelector
        formGroupProps={{
          className: "mt-3",
        }}
        className="w-3/4"
        fill
        label="Add Departments"
        query={DEPARTMENT_LIST}
        value={departments}
        onChange={(_, value) => setDepartments(value)}
      />
      <ButtonMutation
        icon="confirm"
        text="Update Departments"
        onError={err => {
          AppToaster.show({
            icon: "cross",
            intent: "danger",
            message: "Unable to bulk add departments!",
          })
        }}
        onCompleted={data => {
          AppToaster.show({
            intent: "success",
            icon: "endorsed",
            message: `Updated statuses of ${data?.bulkAddVehicleDepartment?.vehicles?.length} vehicles`,
          })
        }}
        mutation={BULK_UPDATE_VEHICLE_DEPARTMENTS}
        variables={{
          vehicles: Object.keys(selected),
          departments: departments?.map(getId),
        }}
      />
    </>
  )
}
export default UpdateDepartments
